import { ViewResolver } from '@Components/ViewResolver';
import { TenderTotalAmountResponse } from '@Types/api/form/tenderRequest/TenderTotalAmountResponse';
import PriceBreakdownDesktop from './desktop/PriceBreakdownDesktop';
import PriceBreakdownMobile from './mobile/PriceBreakdownMobile';

export interface PriceBreakdownProps {
  onClose: () => void;
  isOpen: boolean;
  total: TenderTotalAmountResponse;
}

const PriceBreakdown: React.FC<PriceBreakdownProps> = ({
  isOpen,
  onClose,
  total,
}) => {
  return (
    <ViewResolver
      desktop={<PriceBreakdownDesktop total={total} onClose={onClose} />}
      mobile={
        <PriceBreakdownMobile
          total={total}
          isOpen={isOpen}
          onCancel={onClose}
        />
      }
    />
  );
};

export default PriceBreakdown;
